import { render, staticRenderFns } from "./PostIndexesDatatable.vue?vue&type=template&id=969a585a&scoped=true"
import script from "./PostIndexesDatatable.vue?vue&type=script&lang=js"
export * from "./PostIndexesDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969a585a",
  null
  
)

export default component.exports